import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { selectMemberProfile } from '@lib/members/data-access';
import { Store } from '@ngrx/store';

import { AppointmentsListComponent } from '@hm/ui/lists/appointments-list/appointments-list.component';

import { MemberProfile } from '@lib/core/models/member.interface';

@Component({
  standalone: true,
  selector: 'members-appointments',
  imports: [AppointmentsListComponent],
  templateUrl: './member-appointments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberAppointmentsComponent {
  private readonly store = inject(Store);

  protected readonly memberProfile = this.store.selectSignal<MemberProfile>(selectMemberProfile);
}
